<!-- Top Navigation Bar -->
<mat-toolbar [ngClass]="{'top-toolbar': true, 'parent-mode-toolbar': !isChildMode}" color="primary">
  <!-- App Logo -->
  <span class="app-logo">STRAWJAR</span>
  
  <!-- Parent mode indicator -->
  <span *ngIf="!isChildMode" class="parent-mode-indicator">Parent Mode</span>
  
  <!-- Child's straw balance -->
  <div class="straw-balance" *ngIf="loggedInChild$ | async as child">
    <img src="assets/red_straw.png" alt="Straw" class="straw-icon">
    <span>{{child.points}}</span>
  </div>
  
  <span class="spacer"></span>
  
  <!-- Screen Saver Button -->
  <button mat-icon-button (click)="activateScreenSaver()" matTooltip="Activate Screen Saver">
    <mat-icon>tv_off</mat-icon>
  </button>
  
  <!-- Temporary Delete All Chores Button -->
  <!-- <button mat-icon-button (click)="deleteAllChores()" matTooltip="Delete All Chores (Testing)" *ngIf="!isChildMode">
    <mat-icon color="warn">delete_forever</mat-icon>
  </button> -->
  
  <!-- Dark/Light Theme Toggle -->
  <button mat-icon-button (click)="toggleTheme()" class="theme-toggle" matTooltip="Toggle theme">
    <mat-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
  </button>
  
  <!-- Refresh Button -->
  <button mat-icon-button (click)="refreshApp()" matTooltip="Refresh app">
    <mat-icon>refresh</mat-icon>
  </button>
  
  <!-- Mail Button - only show if user is logged in -->
  <!-- Mail button -->
  <a *ngIf="auth.currentUser$ | async" 
     mat-icon-button 
     [routerLink]="['/mail']" 
     matTooltip="Messages"
     class="mail-button">
    <mat-icon [matBadge]="unreadCount$ | async" 
              [matBadgeHidden]="(unreadCount$ | async) === 0"
              matBadgeColor="accent">mail</mat-icon>
  </a>
  
  <!-- Test button for routing diagnostic -->
  <a *ngIf="auth.currentUser$ | async"
     mat-icon-button
     [routerLink]="['/test']"
     matTooltip="Test Route">
    <mat-icon>bug_report</mat-icon>
  </a>
  
  <ng-container *ngIf="auth.currentUser$ | async as user; else signIn">
    <!-- Wrap user name and profile button in a container for alignment -->
    <div class="user-profile-container">
      <!-- Display user name -->
      <span class="user-name">
        <ng-container *ngIf="isChildMode && (loggedInChild$ | async) as child">
          {{ child.displayName }}
        </ng-container>
        <ng-container *ngIf="!isChildMode">
          {{ user.displayName || user.email }}
        </ng-container>
      </span>
      
      <!-- Only show profile button in parent mode or when child is logged in -->
      <button *ngIf="!isChildMode || (isChildMode && (loggedInChild$ | async))" 
              mat-icon-button 
              [matMenuTriggerFor]="profileMenu" 
              class="profile-button">
        <div class="profile-content">
          <!-- Show image if available -->
          <img *ngIf="profileImage$ | async as profileImg" 
               [src]="profileImg"
               alt="Profile"
               class="profile-image">
          <!-- Show initials if no image available -->
          <div *ngIf="!(profileImage$ | async)" class="profile-initials">
            <ng-container *ngIf="isChildMode && (loggedInChild$ | async) as child">
              {{ getInitials(child.displayName) }}
            </ng-container>
            <ng-container *ngIf="!isChildMode">
              {{ getInitials(user.displayName || user.email) }}
            </ng-container>
          </div>
        </div>
      </button>
    </div>
  </ng-container>
  
  <ng-template #signIn>
    <button mat-button routerLink="/login">
      <mat-icon>login</mat-icon>
      <span>Sign In</span>
    </button>
  </ng-template>
</mat-toolbar>

<!-- Profile Menu -->
<mat-menu #profileMenu="matMenu">
  <!-- Child Menu Options -->
  <ng-container *ngIf="isChildMode">
    <button mat-menu-item (click)="childAuth.logoutChildStayInChildMode()">
      <mat-icon>logout</mat-icon>
      <span>Log Out</span>
    </button>
  </ng-container>

  <!-- Parent Menu Options -->
  <ng-container *ngIf="!isChildMode">
    <button mat-menu-item routerLink="/profile">
      <mat-icon>person</mat-icon>
      <span>Profile</span>
    </button>
    <button mat-menu-item routerLink="/account">
      <mat-icon>settings</mat-icon>
      <span>Account</span>
    </button>
    <button mat-menu-item routerLink="/settings">
      <mat-icon>people</mat-icon>
      <span>Children</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Log Out</span>
    </button>
  </ng-container>
</mat-menu>

<!-- Main Content Area -->
<main [class.no-bottom-padding]="!(auth.currentUser$ | async)">
  <router-outlet></router-outlet>
</main>

<!-- Bottom Navigation Bar -->
<mat-toolbar class="bottom-toolbar" *ngIf="auth.currentUser$ | async">
  <button mat-button routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
    <mat-icon>dashboard</mat-icon>
  </button>
  
  <button mat-button routerLink="/chores" routerLinkActive="active">
    <mat-icon>assignment</mat-icon>
  </button>
  
  <button mat-button routerLink="/prizes" routerLinkActive="active">
    <mat-icon>card_giftcard</mat-icon>
  </button>
  
  <button mat-button routerLink="/bank" routerLinkActive="active">
    <mat-icon>savings</mat-icon>
  </button>
  
  <button mat-button routerLink="/games" routerLinkActive="active">
    <mat-icon>sports_esports</mat-icon>
  </button>
</mat-toolbar> 